import React, { Component } from 'react'
import { Form, Field } from 'redux-form'
import OperatorField from '../components/OperatorField'
import cn from 'classnames'
import Button from 'components/Button'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'
import SelectPretty from 'components/Input/SelectPretty'
import { vRequired } from 'components/Input/Input.validations'

const options = [
  {
    value: 'id',
    name: 'id',
  },
  {
    value: 'userId',
    name: 'userId',
  },
  {
    value: 'firstName',
    name: 'firstName',
  },
  {
    value: 'lastName',
    name: 'lastName',
  },
  {
    value: 'company',
    name: 'company',
  },
  {
    value: 'email',
    name: 'email',
  },
  {
    value: 'phoneNumber',
    name: 'phoneNumber',
  },
]

export default class ContactDataIsForm extends Component {
  render() {
    const { handleSubmit, className, onSubmit, node, nodeInfo, formData, change } = this.props
    const submit = data => onSubmit(node, { extras: data })

    return (
      <Form onSubmit={handleSubmit(submit)} className={className}>
        <div style={{ paddingBottom: '15px' }} className={sText.descrip3}>
          This node allows you to change your flow based on variable data about the contact. If the
          variable is empty this will evaluate to false.{' '}
          <a href={nodeInfo.helpUrl} target="_blank" rel="noopener noreferrer">
            {' '}
            Learn more.
          </a>
        </div>
        <Field
          label="Contact Variable"
          component={SelectPretty}
          name="variable"
          options={options}
          validate={[vRequired]}
          manualInput
          manualInputPlaceholder="customFields.example"
        />
        <OperatorField
          change={change}
          formData={formData}
          operators={['is', 'anyOf', 'contains', 'regex']}
        />
        <div className={sLay.flex} />
        <div className={cn(sLay['layout-column'])}>
          <Button type="submit" color="tertiary" rect>
            Save Node
          </Button>
        </div>
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/ContactDataIs/ContactDataIsForm.jsx